import type { ComputedRef, InjectionKey } from 'vue';
import type { UseQueryReturnType } from '@tanstack/vue-query';
import type { AccountingInfo } from '@/types/deepadmin/AccountingInfo';
import type { OrganizationBranding } from '@/types/deepadmin/Branding';
import type { AvailableModes } from '@/types/deepsign/AvailableModes';
import type { CompanySettings } from '@/types/deepsign/CompanySettings';

export interface OrganizationPageContext {
  settingsQuery?: UseQueryReturnType<CompanySettings, Error>;
  availableModesQuery?: UseQueryReturnType<AvailableModes, Error>;
  accountingQuery?: UseQueryReturnType<AccountingInfo, Error>;
  brandingsQuery: UseQueryReturnType<OrganizationBranding, Error>;
  isLoadingOrganizationData: ComputedRef<boolean>;
}

export const organizationPageKey: InjectionKey<OrganizationPageContext> =
  Symbol('OrganizationPageContext');
